<template>
  <div class="flex justify-between">
    <RfSwitch
      :modelValue="modelValue"
      :disabled="disabled"
      title="Active"
      @update:modelValue="value => emit('update:modelValue', value)"
    />
    <RfTestPushSender
      channel="apns"
      :disabled="disabled || (formDirty && 'Save your changes first')"
      class="mt-2"
    />
  </div>
</template>

<script setup>
import RfSwitch from "@/components/inputs/RfSwitch.vue";
import RfTestPushSender from "@/components/RfPromotions/RfTestPushSender.vue";

defineProps({
  modelValue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  formDirty: { type: [Boolean, String], default: false },
});

const emit = defineEmits(["update:modelValue"]);
</script>
